import { IonButtons,IonGrid, IonCol, IonContent, IonHeader,IonIcon, IonMenuButton, IonPage, IonRow, IonText, IonTitle, IonToolbar } from '@ionic/react';

const Abrev = () => {

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle>Abreviaturas</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent fullscreen className="IonPadding">
                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle size="large">Abreviaturas</IonTitle>
                    </IonToolbar>
                </IonHeader>

                <IonGrid className="ion-padding-start ion-padding-end extra-padding ion-padding-bottom ion-margin-bottom">
         
                <IonRow className="mt2  mx2 mb1 "><IonText>ARAII: Antagonistas de los receptores de la Angiotensina II</IonText></IonRow>
                <IonRow className="mt2  mx2 mb1 "><IonText>ARM: Antagonistas de los receptores de mineralocorticoides</IonText></IonRow>
                <IonRow className="mt2  mx2 mb1 "><IonText>BB: Betabloqueantes </IonText></IonRow>
                <IonRow className="mt2  mx2 mb1 "><IonText>DIU: Diur&eacute;ticos de asa </IonText></IonRow>
      <IonRow className="mt2  mx2 mb1 "><IonText>FC: Frecuencia Cardiaca </IonText></IonRow>
     <IonRow className="mt2  mx2 mb1 "><IonText>FE: Fracci&oacute;n de Eyecci&oacute;n</IonText></IonRow>
      <IonRow className="mt2  mx2 mb1 "><IonText>IC: Insuficiencia Cardiaca </IonText></IonRow>
      <IonRow className="mt2  mx2 mb1 "><IonText>IECA: Inhibidores de la enzima convertidora de la Angiotensina</IonText></IonRow>
      <IonRow className="mt2  mx2 mb1 "><IonText>INRA: Inhibidores de la neprilisina y del receptor de Angiotensina II </IonText></IonRow>
      <IonRow className="mt2  mx2 mb1 "><IonText>iSGLT2: Inhibidores del cotransportador de sodio-glucosa de tipo 2</IonText></IonRow>
      <IonRow className="mt2  mx2 mb1 "><IonText>K+: Potasio</IonText></IonRow>
      <IonRow className="mt2  mx2 mb1 "><IonText>TAS: Tensi&oacute;n arterial sist&oacute;lica</IonText></IonRow>
      <IonRow className="mt2  mx2 mb1 "><IonText>TFG: Tasa de filtrado glomerular</IonText></IonRow>

               </IonGrid>
            </IonContent>
        </IonPage>
    );
};

export default Abrev;
